import { createContext } from 'react';

const TutorialContext = createContext({
  restartTutorial: () => {},
});

export default TutorialContext;
